import { createLabeledMessages } from '../../../messageUtils';
const special = {
    char_zero: 'znak',
    char_few: 'znaky',
    char_other: 'znaků',
    file_zero: 'souborů',
    file_one: 'soubor',
    file_few: 'soubory',
    file_other: 'souborů'
};
const common = {
    yes: 'ano',
    no: 'ne',
    unknown: 'neznámo',
    choose: 'vybrat',
    close: 'zavřít',
    name: 'název',
    note: 'poznámka',
    from: 'od',
    to: 'do',
    pageSize: 'zobrazeno',
    loading: 'Načítám',
    back: 'Zpět',
    ok: 'Ok',
    loadingApplication: 'Načítám aplikaci'
};
const auth = {
    accessDenied: 'Nemáte přístup na tuto komponentu'
};
const generic = {
    noRecord: 'Žádný záznam',
    noRecordFound: 'Nebyl nalezen žádný záznam',
    configuratorError: 'Stránku se nepodařilo načíst. Opakujte akci znovu.',
    configuratorLoading: 'Načítám, prosím čekejte.',
    delegationNoAccessLogin: 'Do této aplikace nemáte právo zástupu za {{login}}.',
    delegationNoAccessRedirect: 'Budete přesměrováni na seznam zástupů.',
    noAccess: 'Nemáte přístupová práva do aplikace.',
    update: 'Opakovat',
    errorDetailLabel: 'Výpis chyby',
    instructionLabel: 'Pokud se chyba opakovaně vyskytuje, založte helpdesk a přiložte výpis chyby. Kód zkopírujete zde.',
    searchEllipsis: 'Vyhledat...',
    search: 'Hledat',
    copied: 'Zkopírováno',
    provideDetailsInReport: 'Údaje uveďte při nahlášení chyby, např. přes aplikaci HelpDesk',
    retry: 'Zkusit znovu',
    error: 'Chyba',
    closeAll: 'Zavřít vše',
    application: 'Aplikace',
    user: 'Uživatel',
    logout: 'Odhlásit se',
    darkMode: 'Tmavý režim',
    delete: 'Smazat',
    uploadFile: 'Nahrát soubor',
    minCharacterCount: 'Zadejte alespoň {{count}} znaky',
    loadingData: 'Načítám data',
    missingStateParameter: 'Chybí povinný vstupní parametr'
};
const dropZone = {
    infoText: 'Lze nahrát <strong>{{extensions, list}}</strong>. Maximální velikost souboru je <strong>{{size, number(style: unit; unit: megabyte)}}</strong>. ',
    totalAcceptSize: 'Celkem lze nahrát <strong>{{size, number(style: unit; unit: megabyte)}}</strong>. ',
    chipWithSize: '{{name}} ({{size, number(style: unit; unit: megabyte)}})',
    choseFileDesktop: 'vyberte soubor',
    choseFileMobile: 'Vybrat soubor',
    dragFile: 'Přetáhněte soubor sem nebo',
    wrongFormat: 'Tento formát bohužel nepodporujeme.',
    numOfFiles: "Můžete nahrát maximálně <strong>{{numOfFiles}} $t(common:file, {'count': {{numOfFiles}}})</strong>."
};
const mimeTypes = {
    //audio,application,image,text,video,font
    'mime-audio': 'audio soubory',
    'mime-application': 'aplikační soubory',
    'mime-image': 'obrázky',
    'mime-text': 'textové soubory',
    'mime-video': 'video soubory',
    'mime-font': 'fonty'
};
const externalLink = {
    externalLinkLoading: 'Načítání odkazu, čekejte prosím.',
    externalLinkError: 'Při načítání odkazu došlo k chybě.'
};
const messages = Object.assign({}, special, common, auth, generic, dropZone, mimeTypes, externalLink);
export default Object.assign({}, messages, createLabeledMessages(messages));
